import {useEffect, useState} from "react";
import {useAuth} from "../../../../AuthProvider/AuthProvider";
import {patchJob} from "../../../../../utils/apiCalls";
import {TapeProcessingView} from "../../../../../component/processing/TapeProcessingView";
import {ORDER_SHIPPING_STATUSES} from "../../../../../utils/constants";

export const Processing = ({orderDetail, customer, onOrderUpdate}) => {
    const {isAdmin, user} = useAuth();
    const [derivedCounts, setDerivedCounts] = useState(null);

    // For admin (CID=0), use the customer's arkbridge_customer_id so SaaS routes correctly
    const effectiveCid = customer?.arkbridge_customer_id
        ? parseInt(customer.arkbridge_customer_id, 10)
        : (isAdmin ? 0 : user?.arkbridge_customer_id);

    // Auto-derive order status after tape data loads
    useEffect(() => {
        if (!derivedCounts) return;
        const {entriesCount, completedCount} = derivedCounts;
        if (entriesCount === 0) return;
        if (ORDER_SHIPPING_STATUSES.includes(orderDetail?.status) || orderDetail?.status === 'draft') return;

        const targetStatus = (completedCount === entriesCount) ? "ingestion_complete" : "audit_started";
        if (orderDetail?.status !== targetStatus) {
            patchJob(orderDetail.uuid, orderDetail.customer, {status: targetStatus})
                .then(data => { if (data && onOrderUpdate) onOrderUpdate(data); })
                .catch(err => console.log("Auto order-status update error:", err));
        }
    }, [derivedCounts]);

    return (
        <TapeProcessingView
            orderDetail={orderDetail}
            cid={effectiveCid}
            onDataLoaded={setDerivedCounts}
            showHeading={false}
        />
    );
};
